import * as React from "react"
import { ReactNode } from "react"

interface ErrorBoundaryState {
    hasError: boolean
}

interface ErrorBoundaryProps {
    fallbackComponent: ReactNode
    children: React.ReactNode
}

export class ErrorBoundary extends React.Component<ErrorBoundaryProps, ErrorBoundaryState> {
    constructor(props: ErrorBoundaryProps) {
        super(props)
        this.state = { hasError: false }
    }

    async componentDidCatch(error: Error): Promise<void> {
        this.setState({ hasError: true })
    }

    render() {
        const { state, props } = this
        if (state.hasError) {
            return props.fallbackComponent
        }

        return props.children
    }
}
